let filteredCollectionSection = null;
let hFilterCollectionTime = setInterval(() => {
  filteredCollectionSection = document.querySelector('.shopify-section-filter-collection');
  if(filteredCollectionSection) {
    clearInterval(hFilterCollectionTime);
    fetchFilteringProducts();
  }
}, 100);
document.addEventListener('DOMContentLoaded',()=>{
  clearInterval(hFilterCollectionTime);
  if(!filteredCollectionSection) {
    filteredCollectionSection = document.querySelector('.shopify-section-filter-collection');
    if(filteredCollectionSection) {
      fetchFilteringProducts();
    }
  }

  const blogSections = document.querySelectorAll('.shopify-section--blog-new');
  blogSections.forEach(blogSection=>{
    const tagFilterItems = blogSection.querySelectorAll('.tag-item');
    const clearTagFilter = blogSection.querySelector('.tag-item.clear-tag');
    const filterItems = [];
    let hTime = null;
    tagFilterItems.forEach(tagFilterItem=>{
      tagFilterItem.addEventListener('click',()=>{
        if(tagFilterItem.classList.contains('clear-tag')) {
          filterItems.splice(0,filterItems.length);
          tagFilterItems.forEach(item=>{
            item.classList.remove('selected');
          });
          tagFilterItem.classList.add('hidden');
          fetchBlogPostsByTag({section: blogSection,tags:[]});
        } else {
          const tag = tagFilterItem.getAttribute('link');
          if(tagFilterItem.classList.contains('selected')) {
            const index = filterItems.indexOf(tag);
            if(index > -1) {
              filterItems.splice(index, 1);
              tagFilterItem.classList.remove('selected');
              if(filterItems.length === 0) {
                clearTagFilter?.classList.add('hidden');
              }
            }
          } else {
            tagFilterItem.classList.add('selected');
            filterItems.push(tag);
            clearTagFilter?.classList.remove('hidden');
          }
          if(hTime !== null) {
            clearTimeout(hTime);
            hTime = null;
          }
          hTime = setTimeout(() => {
            hTime = null;
            fetchBlogPostsByTag({section: blogSection,tags:filterItems});
          }, 500);
        }
      });
    });
    triggerClickImage({section: blogSection});
  });

  const articleSections = document.querySelectorAll('.shopify-section--article-new');
  articleSections.forEach(articleSection=>{
    articleSection.querySelectorAll('.product-card .image').forEach(productCardImage=>{
      productCardImage.addEventListener('click',()=>{
        const link = productCardImage.getAttribute('link');
        location.href=  link;
      });
    });
    articleSection.querySelector('.print-icon')?.addEventListener('click',()=>{
      window.print();
    });
  });
  document.querySelectorAll('.media-block').forEach(mediaBlock=>{
    mediaBlock.addEventListener('click',()=>{
      const link = mediaBlock.getAttribute('link');
      if(link) {
        location.href = link;
      }
    });
  });
});

const fetchBlogPostsByTag = ({section,tags}) => {
  if(section instanceof HTMLElement && tags instanceof Array) {
    const tagsAsString = tags.join('+');
    let url = `${location.pathname}`;
    if(tags.length > 0) {
      url += `/tagged/${tagsAsString}`;
    }
    fetch(url).then(res=>res.text()).then(res=>{
      const parser = new DOMParser();
      const virtualDom = parser.parseFromString(res,'text/html');
      const postList = section.querySelector('.article-list');
      const pagination = section.querySelector('.pagination-row');
      const virtualPostList = virtualDom.querySelector('.article-list');
      const virtualPagination = virtualDom.querySelector('.pagination-row');
      if(postList && virtualPostList) {
        postList.innerHTML = virtualPostList.innerHTML;
        setTimeout(() => {
          triggerClickImage({section});
        }, 100);
      }
      if(pagination && virtualPagination) {
        pagination.innerHTML = virtualPagination.innerHTML;
      }
    });
  }
}
const triggerClickImage = ({section}) => {
  if(section instanceof HTMLElement) {
    section.querySelectorAll('.article-image').forEach(articleImage=>{
      articleImage.addEventListener('click',()=>{
        const link = articleImage.getAttribute('link');
        location.href = link;
      });
    });
  }
}
const fetchFilteringProducts = async () => {
  const section = document.querySelector('.shopify-section-filter-collection');
  const collectionUrl = section.getAttribute('collection');
  if(!collectionUrl) {
    return;
  }
  const maxCount = parseInt(section.getAttribute('max-count')) || 50;
  const defaultTab = section.querySelector('.filtered-collection:not(.hidden)');
  const defaultProductList = defaultTab.querySelectorAll('.product-list');

  defaultTab.classList.add('loading');
  for (const productList of defaultProductList) {
    await fetchProductsByTag({collectionUrl,content:productList,maxCount})
  }
  defaultTab.classList.remove('loading');
  section.querySelectorAll('.tab-header-item').forEach(tabHeaderItem=>{
    tabHeaderItem.addEventListener('click',async ()=>{
      if(tabHeaderItem.classList.contains('active')) {
        return;
      }
      const currentItem = section.querySelector('.tab-header-item.active');
      if(currentItem) {
        const index = currentItem.getAttribute('index');
        currentItem.classList.remove('active');
        section.querySelector(`.filtered-collection[index="${index}"]`)?.classList.add('hidden');
      }
      tabHeaderItem.classList.add('active');
      const currentIndex = tabHeaderItem.getAttribute('index');
      const tabContent = section.querySelector(`.filtered-collection[index="${currentIndex}"]`);
      tabContent.classList.remove('hidden');
      if(tabContent.classList.contains('need-to-load')) {
        const currentTabProductList = tabContent.querySelectorAll(`.product-list`);
        tabContent.classList.add('loading');
        for (const productList of currentTabProductList) {
          await fetchProductsByTag({collectionUrl,content: productList,maxCount});
        }
        tabContent.classList.remove('loading');
        tabContent.classList.remove('need-to-load');
      }
    });
  });
}
const fetchProductsByTag = async ({collectionUrl,content,maxCount}) => {
  if(collectionUrl && content instanceof HTMLElement) {
    const tagName = content.getAttribute('tag');
    const newUrl = collectionUrl + (tagName?`/${tagName}`:'');
    const res = await fetch(newUrl);
    const resData = await res.text();
    const parser = new DOMParser();
    const virtualDom = parser.parseFromString(resData,'text/html');
    const productItems = virtualDom.querySelectorAll('.product-block');
    content.innerHTML = '';
    for (const [index,product] of productItems.entries()) {
      if(index >= maxCount) {
        break;
      }
      content.appendChild(product.cloneNode(true));
    }
  }
}